<template lang="pug">
.field-modal-select
	.field-modal-select__header
		h3.field-modal-select__title
			span.field-modal-select__title-text(v-if="field.title" ) &nbsp;{{ field.title }}
	.field-check-list__items
		.field-check-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
			label.v-field-checkbox.field-checkbox
				input.field-checkbox__input(
					:type="'radio'"
					:value="option.value"
					v-model="localValue"
					:disabled="field.disabled || option.disabled"
					:id="uniqueId + index")
				.field-checkbox__button {{option.text}}
	.field-check-list__buttons(v-if="field.buttons")
		button.field-check-list__button(v-for="(button, index) in field.buttons"
			:key="index"
			:class="button.className"
			@click="handleInput")
			| {{ button.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
import uniqueId from "../scripts/helpers/uniqueId.js";

export default {
	mixins: [sourceMixin],

	props: {
		modelValue: {
			type: [Object, String, Number],
			default: null
		},
	},

	emits: [
		'update:model-value',
		'change-select',
	],

	data() {
		return {
			field: null,
			localValue: null,
			uniqueId: uniqueId('field-'),
		};
	},

	methods: {
		dataSet(data) {
			this.field = data;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
			this.$emit('change-select', this.localValue);
			controller.closeModal()
		},

	},

	// watch: {
	// 	localValue() {
	// 		this.$emit('change-select', this.localValue);
	// 	},
	//
	// },

	created() {
		this.localValue = this.modelValue;
	},

}

</script>